import {
  FETCH_APPS_LIST_SUCCESS,
  FETCH_APPS_LIST_ASYNC_START,
  FETCH_APPS_LIST_ASYNC_END,
  MANAGER_REMOVE_APP_SUCCESS,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function teachersList(state = {}, action) {
  switch (action.type) {
    case FETCH_APPS_LIST_SUCCESS:
      return { ...action.apps, count: action.count }

    case FETCH_APPS_LIST_ASYNC_START:
      return { ...state, aSyncCall: true }

    case FETCH_APPS_LIST_ASYNC_END:
      return { ...state, aSyncCall: false }

    case MANAGER_REMOVE_APP_SUCCESS:
      const { userId } = action
      return dotProp(state)
        .delete(`entities.apps.${userId}`)
        .set('result', result => result.filter(ids => ids !== userId))
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appsList.js